import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getFiduciaryClientDefaultFunds = async ({ selectedClient, removedFiduciaryFund, productId }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciary-clients/${selectedClient}/funds/${removedFiduciaryFund}/products/${productId}/default-funds`;
  return request.get(url);
};
export const getFiduciaryClientDefaultFundsV2 = async ({ selectedClient, removedFiduciaryFund, productId }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciary-clients/${selectedClient}/funds/${removedFiduciaryFund}/products/${productId}/default-funds/V2`;
  return request.get(url);
};

/* eslint-disable */
export const getFiduciaryClientFilterReplacementsByCategory = async ({ selectedClient, removedFiduciaryFund, productId, categories }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciary-clients/${selectedClient}/funds/${removedFiduciaryFund}/products/${productId}/?category=${categories}`;
  return request.get(url);
};

export const getFiduciaryClientFilterReplacementsByCategoryV2 = async ({ selectedClient, removedFiduciaryFund, productId, categories }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciary-clients/${selectedClient}/funds/${removedFiduciaryFund}/products/${productId}/V2?category=${categories}`;
  return request.get(url);
};

/* eslint-disable */
export const getFiduciaryClientFilterReplacementsBySearch = async ({ selectedClient, removedFiduciaryFund, productId, searchTerm }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciary-clients/${selectedClient}/funds/${removedFiduciaryFund}/products/${productId}/?search=${searchTerm}`;
  return request.get(url);
};

export const replacePendingProductFiduciaryFunds = async ( payload ) => {
  const url = `/pendingproductfiduciaryfunds`;
  return request.post(url, payload);
};

export const replacePendingProductFiduciaryFundsV2 = async ( payload ) => {
  const url = `/pendingproductfiduciaryfunds/V2`;
  return request.post(url, { data: JSON.stringify(payload) });
};

/* eslint-disable */
export const undoPendingProductFiduFundsReplacement = async ({ fiduciaryNumber, payload }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciaries/${fiduciaryNumber}/pending-product-fiduciary-funds/undo`;
  return request.post(url, { data: JSON.stringify(payload) });
};

export const undoPendingProductFiduFundsReplacementV2 = async ({ fiduciaryNumber, payload }) => {
  const url = `/fiduciaries/${fiduciaryNumber}/pending-product-fiduciary-funds/undo/V2`;
  return request.post(url, { data: JSON.stringify(payload) });
};

/* eslint-disable */
export const submitPendingProductFiduFundsReplacement = async ({ fiduciaryNumber, payload }) => {
  /* eslint-disable-next-line max-len */
  const url = `/fiduciaries/${fiduciaryNumber}/pending-product-fiduciary-funds/submit`;
  return request.post(url, { data: JSON.stringify(payload) });
};

export const submitPendingProductFiduFundsReplacementV2 = async ({ fiduciaryNumber, payload }) => {
  const url = `/fiduciaries/${fiduciaryNumber}/pending-product-fiduciary-funds/submit/V2`;
  return request.post(url, { data: JSON.stringify(payload) });
};

export const getReplacementMenus = async (selectedClient, removedFundId, replacementFundId, productId) => {
  const url = `/fiduciary-clients/${selectedClient}/removedFund/${removedFundId}/replacementFund/${replacementFundId}/products/${productId}/default-menus`;
  return request.get(url);
}